import React from "react";

import DrawerToggleButton from "../SideDrawer/DrawerToggleButton";
import "./Toolbar.css";
import Logo from "../../assets/image/AtlasLogoTransparentSide.png";

import { Link, NavLink, useLocation } from "react-router-dom";

const Toolbar = (props) => {
	const location = useLocation();
	
	const isActive = (pathname, state = {}) => {
		return (
			location.pathname === pathname &&
			(!state.lang ||
				(location.state && location.state.lang === state.lang))
		);
	};

	return (
		<header className="toolbar">
			<nav className="toolbar_navigation">
				<div className="toolbar_toggle-button">
					<DrawerToggleButton click={props.drawerClickHandler} />
				</div>
				<div className="toolbar_logo">
					<Link to="/">
						<img
							src={Logo}
							alt="Atlas"
							className="NavbarLogo"
							focusable="false"
						/>
					</Link>
				</div>
				<div className="spacer" />
				<div className="toolbar_navigation-items">
					<ul>
						<div className="sjukrathjalfun">
							<NavLink
								end
								to="/sjukrathjalfun"
								state={{ lang: "icelandic" }}
								className={`mainNavLink ${
									isActive("/sjukrathjalfun", { lang: "icelandic" })
										? "activeTab"
										: ""
								}`}
							>
								Sjúkraþjálfun
							</NavLink>
							<ul>
								<li>
									<NavLink
										end
										to="/sjukrathjalfun/gjaldskra"
										className={({ isActive }) => 
											`sjukrathjalfunUnderLink ${isActive ? "activeTab" : ""}`
										}
									>
										Gjaldskrá
									</NavLink>
								</li>
								<li className="toolbarLang toolbarLangFirst">
									<NavLink
										end
										to="/sjukrathjalfun"
										state={{ lang: "english" }}
										className={`sjukrathjalfunUnderLink ${
											isActive("/sjukrathjalfun", { lang: "english" })
												? "activeTab"
												: ""
										}`}
									>
										English
									</NavLink>
								</li>
								<li className="toolbarLang">
									<NavLink
										end
										to="/sjukrathjalfun"
										state={{ lang: "spanish" }}
										className={`sjukrathjalfunUnderLink ${
											isActive("/sjukrathjalfun", { lang: "spanish" })
												? "activeTab"
												: ""
										}`}
									>
										Español
									</NavLink>
								</li>
							</ul>
						</div>

						<div className="starfsfolk">
							<NavLink
								to="/starfsfolk"
								className={({ isActive }) => 
									`mainNavLink ${isActive ? "activeTab" : ""}`
								}
							>
								Starfsfólk
							</NavLink>
						</div>

						<div className="umOkkur">
							<NavLink
								end
								to="/umokkur"
								className={({ isActive }) => 
									`mainNavLink ${isActive ? "activeTab" : ""}`
								}
							>
								Um okkur
							</NavLink>
							<ul>
								<li>
									<NavLink
										end
										to="/umokkur/stadsetning"
										className={({ isActive }) => 
											`umOkkurUnderLink ${isActive ? "activeTab" : ""}`
										}
									>
										Staðsetning
									</NavLink>
								</li>

								<li>
									<NavLink
										end
										to="/umokkur/personuvernd"
										className={({ isActive }) => 
											`umOkkurUnderLink ${isActive ? "activeTab" : ""}`
										}
									>
										Persónuvernd
									</NavLink>
								</li>
							</ul>
						</div>

						<div className="frettir">
							<NavLink
								to="/frettir"
								className={({ isActive }) => 
									`mainNavLink ${isActive ? "activeTab" : ""}`
								}
							>
								Fréttir og greinar
							</NavLink>
						</div>

						<div className="hafasamband">
							<NavLink
								to="/timabokun"
								className={({ isActive }) => 
									`mainNavLink ${isActive ? "activeTab" : ""}`
								}
							>
								Hafa samband
							</NavLink>
						</div>
					</ul>
				</div>
			</nav>
		</header>
	);
};

export default Toolbar;
